import Splide from "@splidejs/splide";

const initialiseSplide = () => {
  const postCarousel = document.querySelectorAll(
    ".page-posts-splide"
  ) as NodeListOf<HTMLElement>;
  const testimonialCarousels = document.querySelectorAll(
    ".testimonial-carousel-splide"
  ) as NodeListOf<HTMLElement>;

  for (let i = 0; i < postCarousel.length; i++) {
    const carouselSlides = postCarousel[i].querySelectorAll('.splide__slide');

    new Splide(postCarousel[i], {
      perPage: 4,
      type: carouselSlides.length > 4 ? "loop" : 'slide',
      gap: 20,
      arrows: carouselSlides.length > 4 ? true : false,
      breakpoints: {
        1000: {
          perPage: 3,
        },
        800: {
          perPage: 2,
        },
        600: {
          perPage: 1,
        },
      },
    }).mount();
  }
  for (let i = 0; i < testimonialCarousels.length; i++) {
    new Splide(testimonialCarousels[i], {
      perPage: 1,
      type: 'loop',
      width: 'auto',
      arrows: true,
    }).mount();
  }
};

export default initialiseSplide;
